/* Load and scroll motion for the shop homepage and service pages. */
(function () {
  if (window.__ezShopMotion) return;
  window.__ezShopMotion = true;

  function boot() {
    var roots = document.querySelectorAll("[data-ez-shop]");
    if (!roots.length) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var nodes = [];
    roots.forEach(function (root) {
      root.querySelectorAll("h2, .ezink-service__scroll, .ezink-service__facts, .ez-shop__card, .ez-shop__chapter, .ez-shop__steps article, .ez-shop__compare, .ez-shop__close").forEach(function (node) {
        if (node.hasAttribute("data-rise") || node.hasAttribute("data-reveal")) return;
        if (node.closest("[data-reveal], [data-rise]")) return;
        node.setAttribute("data-reveal", "");
        nodes.push(node);
      });
      root.querySelectorAll("[data-reveal]").forEach(function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });

    if (reduce || !("IntersectionObserver" in window)) {
      nodes.forEach(function (node) { node.classList.add("is-in"); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -6% 0px" });

    nodes.forEach(function (node) { observer.observe(node); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
